import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useMemo, useContext } from 'react';

const PasskeyContext = createContext(undefined);
const PasskeyContextProvider = ({ children, }) => {
    // state for when passkey list needs to re-render
    const [passkeyEdited, setPasskeyEdited] = useState(false);
    // states to pass into rename passkey popup
    const [passkey, setPasskey] = useState(undefined);
    const [passkeyIcon, setPasskeyIcon] = useState(undefined);
    const value = useMemo(() => ({
        passkey,
        passkeyEdited,
        passkeyIcon,
        setPasskey,
        setPasskeyEdited,
        setPasskeyIcon,
    }), [passkey, passkeyIcon, passkeyEdited]);
    return (jsx(PasskeyContext.Provider, { value: value, children: children }));
};
const usePasskeyContext = () => {
    const context = useContext(PasskeyContext);
    if (context === undefined) {
        throw new Error('usage of PasskeyContext not wrapped in `PasskeyContextProvider`.');
    }
    return context;
};

export { PasskeyContext, PasskeyContextProvider, usePasskeyContext };
